
import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconResolverService {

    private folders = {
      "magic-filled": 'magic/Filled',
      "magic-regular": 'magic/Regular',
    }

    constructor(
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer
    ) {}

    /**
     *  Initialise un résolveur d'icônes SVG basé sur un dossier donné. -> folders
     *  basePath Chemin de base vers les icônes SVG
     */
    registerIconResolver(basePath = 'assets/images/icons/') {
      this.iconRegistry.addSvgIconResolver((name: string, namespace?: string): SafeResourceUrl | null => {
          let result: SafeResourceUrl = null;
          let folder = null
          if(!!namespace) {
            folder = this.folders[namespace];
          }

          if (!folder) {
              result=null
          } else {
              result = this.sanitizer.bypassSecurityTrustResourceUrl( `${ basePath }${ folder }/${ name }.svg` )
          }
          return result;
        }
      );
    }

}
